import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  UpdateBuyerListPermissionsInput,
  UpdateBuyerListPermissionsMutation,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";

export type AssignedRole = {
  roleName: string | null;
  accessorId: string;
  firstName: string;
  lastName: string;
  email: string;
  active: boolean;
};

const updateBuyerListPermissionsMutation = graphql(`
  mutation updateBuyerListPermissions($input: UpdateBuyerListPermissionsInput!) {
    updateBuyerListPermissions(input: $input) {
      objectId
      accessorId
      accessorType
      roleName
    }
  }
`);

export function useUpdateBuyerListPermissions(
  options?: UseMutationOptions<
    UpdateBuyerListPermissionsMutation,
    unknown,
    UpdateBuyerListPermissionsInput,
    unknown
  >,
) {
  const queryClient = useQueryClient();
  const { mutate: innerMutate, ...rest } = useGraphQlMutation(updateBuyerListPermissionsMutation, {
    onSuccess: (data, variables, context) => {
      void queryClient.invalidateQueries(["buyerLists"]);
      options?.onSuccess?.(data, variables.input, context);
    },
  });
  return {
    ...rest,
    mutate: (input: UpdateBuyerListPermissionsInput) => innerMutate({ input }),
  };
}
